import { memo, useMemo } from 'react'

import { formatMoney } from 'accounting'

import { Table } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import type { AgencyProviderPriceOverrideModel, ProviderPriceListModel } from '@models/types'

import PriceOverrideActions from '../PriceOverrideActions'

const buildColumns = (providerPriceLists: ProviderPriceListModel[]) => [
  {
    title: 'Price List',
    dataKey: 'provider_price_list_id',
    cellProps: {
      width: 200,
    },
    render: (providerPriceListId: number) => {
      const providerPriceList = providerPriceLists[providerPriceListId]
      return providerPriceList?.title
    },
  },
  {
    title: 'Order Item',
    dataKey: 'title',
    render: (title: string, priceOverride: Partial<AgencyProviderPriceOverrideModel>) => {
      // @ts-expect-error TS2339
      const { quantity, options_string } = priceOverride
      return `${quantity} x ${title}${options_string}`
    },
  },
  {
    title: 'Match',
    dataKey: 'price',
    render: (price: string) => formatMoney(price),
  },
  {
    title: 'Override',
    dataKey: 'price_override',
    render: (price_override: string) => formatMoney(price_override),
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      textAlign: 'center',
    },
    render: (id: number) => <PriceOverrideActions priceOverride={{ id }} />,
  },
]

interface PriceOverridesTableProps {
  priceOverrides: AgencyProviderPriceOverrideModel[],
}

const PriceOverridesTable = (props: PriceOverridesTableProps) => {
  const { priceOverrides } = props

  const { providerPriceLists } = useSelector(reduxState => reduxState.entities)

  // @ts-expect-error TS2345
  const memoColumns = useMemo(() => buildColumns(providerPriceLists), [priceOverrides.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      // @ts-expect-error TS2322
      data={priceOverrides}
      stickyHeader
    />
  )
}

export default memo(PriceOverridesTable)
